<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('prep_student_document')"
                        :isNewButton="checkPermission('prepstudentdocument_store')"
                        :isColumns="true"
                        @new-button-click="createFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('prep_student_document')"
                              :isNewButton="checkPermission('prepstudentdocument_store')"
                              :isColumns="true"
                              @new-button-click="createFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns" :key="key">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
            >
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group :label="$t('document_type')">
                            <parameter-selectbox code="prep_student_document_types" v-model="datatable.queryParams.filter.document_type"></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group :label="$t('excuse_start_date')">
                            <select-date v-model="datatable.queryParams.filter.start_date" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group :label="$t('excuse_end_date')">
                            <select-date v-model="datatable.queryParams.filter.end_date" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group :label="$t('level')">
                            <parameter-selectbox code="prep_levels" v-model="datatable.queryParams.filter.level"></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox v-model="datatable.queryParams.filter.academic_year"></academic-years-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group :label="$t('module')">
                            <module-selectbox :academic_year="datatable.queryParams.filter.academic_year" v-model="datatable.queryParams.filter.module_id" valueType="id"></module-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox code="prep_student_document_statuses" v-model="datatable.queryParams.filter.status"></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="showModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('prepstudentdocument_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('prepstudentdocument_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('prepstudentdocument_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    import StudentsAutoCompleteByKey from "@/components/interactive-fields/StudentsAutoCompleteByKey.vue";

    //Page
    import CreateForm from './CreateForm'
    import UpdateForm from './UpdateForm'
    import ShowForm from './ShowForm'

    //Service
    import PrepStudentDocumentService from '@/services/PrepStudentDocumentService';

    //Other
    import qs from 'qs';
    import ModuleSelectbox from "@/components/interactive-fields/ModuleSelectbox.vue";

    export default {
        components: {
            ModuleSelectbox,
            StudentsAutoCompleteByKey,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,

            CreateForm,
            UpdateForm,
            ShowForm
        },
        metaInfo() {
            return {
                title: this.$t('prep_student_document')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'prepstudentdocument_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: 'prepstudentdocument_update',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadData();
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: 'prepstudentdocument_delete',
                                    callback: (row) => {
                                        this.formDelete(row.id);
                                    }
                                },
                                {
                                    text: this.$t('download'),
                                    class: 'ri-download-line',
                                    permission: 'prepstudentdocument_download',
                                    callback: (row) => {
                                        this.download(row);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('student_name'),
                            field: 'student_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('student_surname'),
                            field: 'student_surname',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('nationality'),
                            field: this.getLocaleField('nationality_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('program'),
                            field: this.getLocaleField('program_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('document_type'),
                            field: this.getLocaleField('document_type_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: this.getLocaleField('status_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('excuse_start_date'),
                            field: 'start_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('excuse_end_date'),
                            field: 'end_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('approver_name'),
                            field: 'approver_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('approver_surname'),
                            field: 'approver_surname',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('module'),
                            field: 'module',
                            hidden: false
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                selectedStudent: '',
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                PrepStudentDocumentService.getAll(config).then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                }).finally(() => {
                    this.datatable.isLoading = false;
                });
            },
            loadData() {
                this.formProcess = 'update';
                PrepStudentDocumentService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            formDelete(id) {
                this.$swal
                    .fire({
                        text: this.$t('are_you_sure_to_delete'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no')
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            PrepStudentDocumentService.del(id)
                                .then(response => {
                                    this.$toast.success(this.$t('api.' + response.data.message));
                                    this.getRows();
                                    this.formClear();
                                })
                                .catch(error => {
                                    this.$toast.error(this.$t('api.' + error.data.message));
                                });
                        }
                    })
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            handleSelection(user) {
                this.selectedStudent = user ? `${user.name} ${user.surname}` : '';
                this.datatable.queryParams.filter.student_program_id = user?.student_program_id || null;
            },
            download(row) {
                PrepStudentDocumentService.download(row.id)
                    .then(response=>{
                        this._downloadFile(response, row.file?.name)
                    }).catch(e => {
                    this.showErrors(e, null, true)
                })

            },
        }
    }
</script>
